// components
import { Paper, styled } from '@mui/material';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

export const StyledMultiStepFormSection = styled(MultiStepForm.Section)(() => ({
  borderBottom: 'none'
}));

export const StyledCustomDialogPaper = styled(Paper)({
  width: '75%'
});

export const StyledCustomDialogPaperSmall = styled(Paper)({
  width: '60%'
});
